import React from 'react'

import '../UI/Hero-slider.css';

import Slider from 'react-slick';
import { Container } from 'reactstrap';
import {Link} from 'react-router-dom';

const HeroSlider = () => {
const settings ={
    fade:true,
    speed: 2000,
    autoplaySpeed: 3000,
    infinite: true,
    autoplay:true,
    slidesToShow: 1,
    slidesToScroll:1,
    pauseOnHover: false,
};
return <Slider { ...settings } className="hero__slider">
<div className="slider__item slider__item-01 mt0">
    <Container>
        <div className="slider__content">
            <h1 className="text-light mb3">Ana Cecilia Vivanco </h1>
            <h3 className="mb-4"> ¡Reserva el tuyo ahora! </h3>

            <button className="btn reserve__btn mt-4"> 
            <Link to='/libros'  > Ver más <i class="ri-arrow-right-double-line"></i></Link>
            </button> 

        </div>
    </Container>
</div>


<div className="slider__item slider__item-02 mt0">
    <Container>
        <div className="slider__content">
            <h1 className="text-light mb3">Ana Cecilia Vivanco </h1>
            <h3 className="mb-4"> ¡Reserva el tuyo ahora! </h3>

            <button className="btn reserve__btn mt-4"> 
            <Link to='/libros'  > Ver más <i class="ri-arrow-right-double-line"></i></Link>
            </button>

        </div>
    </Container>
</div>


<div className="slider__item slider__item-03 mt0">
    <Container>
        <div className="slider__content">
            <h1 className="text-light mb3"> Ana Cecilia Vivanco </h1>
            <h3 className="mb-4"> ¡Reserva el tuyo ahora! </h3>

            <button className="btn reserve__btn mt-4"> 
            <Link to='/libros'  > Ver más <i class="ri-arrow-right-double-line"></i></Link>
            </button>

        </div>
    </Container>
</div>
</Slider>
}

export default HeroSlider